import api from './api';

export function getRoutingProfiles() {
  return api.get(`/api/v2/routing-profiles`);
}

export function setRoutingProfiles(profiles) {
  return api.put(`/api/v2/routing-profiles`, profiles);
}
